import { Box, Flex, Stack, useColorMode, useMediaQuery } from "@chakra-ui/react";
import React from 'react';
import Graph from '../Graph';
import CompoundForm from './calculate';
import Result from './result';

function Calculator() {
  const { colorMode } = useColorMode();
  const isDark = colorMode === "dark";
  const [isNotSmallerScreen] = useMediaQuery("(min-width:600px)");

  return (
    <Stack
    mt={isNotSmallerScreen ? "4%" : "25%"}
    py={isNotSmallerScreen ? "2%" : "5"}
    px={isNotSmallerScreen ? "7%" : "2"}
    bg={isDark ? "gray.600" : "#F9F8F3"}
    >
      <Box 
      borderWidth="1px" bg={isDark ? "gray.900" : "white"}
      rounded="lg" shadow="xl">
        <Flex rounded="xl" px={isNotSmallerScreen ? "4" : "0"} py={isNotSmallerScreen ? "5" : "0"}
        direction={isNotSmallerScreen ? "row" : "column"}
        bg={isDark ? "black.100" : "white.10"}
        w="100%">
              <Box alignSelf="center" px="3" py="3" width={isNotSmallerScreen ? "40%" : "100%"}
              >
                  <CompoundForm />
              </Box>
              <Box alignSelf="center" px="3" py="3" width={isNotSmallerScreen ? "60%" : "100%"}>
              <Graph />
              <Result />
              </Box>
        </Flex>
      </Box>
    </Stack>
  )
}

export default Calculator